import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';

interface SVGRProps {
  title?: string;
  titleId?: string;
}

const SvgStopCircleSolidIcon = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M24 2A22 22 0 1 0 46 24 21.9 21.9 0 0 0 24 2Zm8 29a1.1 1.1 0 0 1-1 1H17a1.1 1.1 0 0 1-1-1V17a1.1 1.1 0 0 1 1-1h14a1.1 1.1 0 0 1 1 1Z"
      fill="currentColor"
    />
  </svg>
);

const ForwardRef = forwardRef(SvgStopCircleSolidIcon);
export default ForwardRef;
